var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0F5EFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15630_33217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.625C17.3807 16.625 18.5 15.5057 18.5 14.125C18.5 12.7443 17.3807 11.625 16 11.625C14.6193 11.625 13.5 12.7443 13.5 14.125C13.5 15.5057 14.6193 16.625 16 16.625Z",
    stroke: "#0F5EFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 14.125C22.25 19.75 16 24.125 16 24.125C16 24.125 9.75 19.75 9.75 14.125C9.75 12.4674 10.4085 10.8777 11.5806 9.70558C12.7527 8.53348 14.3424 7.875 16 7.875C17.6576 7.875 19.2473 8.53348 20.4194 9.70558C21.5915 10.8777 22.25 12.4674 22.25 14.125Z",
    stroke: "#0F5EFF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15630_33217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMapPin);
export default __webpack_public_path__ + "static/media/NewMapPin.dc7e583c67042a8371e24ceb52028e6b.svg";
export { ForwardRef as ReactComponent };